import { createAsyncThunk } from "@reduxjs/toolkit";
import VerificationAPI, { AddVerificationsRequest, UpdateVerificationRequest } from "../api/Verifications";
import { VerificationGroupType } from "../api/AnalysisStep";


export const updateVerification = createAsyncThunk<
    void,
    {
        caseId: string, 
        loanRefId: string, 
        group: VerificationGroupType, 
        id: string, 
        request: UpdateVerificationRequest,
        borrowerId?: string;
    },
    {rejectValue: void}
>(
    'verification/update',
    async ({caseId, loanRefId, group, id, request}, {rejectWithValue}) => {
        try{
            await VerificationAPI.update(caseId, loanRefId, group, id, request);
        } catch(error) {
            console.error(error);
            return rejectWithValue()
        }
    }
)

export const addVerifications = createAsyncThunk<
  void,
  {
    caseId: string;
    request: AddVerificationsRequest;
  },
  { rejectValue: void }
>(
  "verification/add",
  async ({ caseId, request }, { rejectWithValue }) => {
    try {
      await VerificationAPI.add(caseId, request);
    } catch (error) {
      console.error(error);
      return rejectWithValue();
    }
  }
);